/**
 * "Remind me later" for the workspace setup prompt.
 * Snoozes are per user and cleared on login/logout, so the prompt returns
 * after the snooze window or on the next sign-in, whichever comes first.
 */

export const SETUP_PROMPT_SNOOZE_MS = 60 * 60 * 1000
const KEY_PREFIX = 'setup-prompt-snooze:'

function snoozeKey(userId) {
  return `${KEY_PREFIX}${userId || 'user'}`
}

export function isSetupPromptSnoozed(userId, now = Date.now()) {
  try {
    const until = Number(localStorage.getItem(snoozeKey(userId)))
    return Number.isFinite(until) && until > now
  } catch {
    return false
  }
}

export function snoozeSetupPrompt(userId, ms = SETUP_PROMPT_SNOOZE_MS, now = Date.now()) {
  try {
    localStorage.setItem(snoozeKey(userId), String(now + ms))
  } catch {
    // storage unavailable: prompt simply returns on the next page
  }
}

export function clearSetupPromptSnoozes() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const key = localStorage.key(i)
      if (key && key.startsWith(KEY_PREFIX)) localStorage.removeItem(key)
    }
  } catch {
    // ignore
  }
}
